import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import { CommonConfig } from '../../configs/config.common';


@Component({
   components: {
      ASpaceInBetweenAnother
   }
})
export default class ListingCard extends Vue {
   public title: string = 'ListingCard';

   public configs = new CommonConfig();

   @Prop({
      default: false
   })
   public featured: any;

   @Prop()
   public data: any;

   // @Prop()
   // public size: any;

   // public cardSizeWidth() {
   //    return this.size / 100 * 320;
   // }

   // public cardSizeHeight() {
   //    return this.size / 100 * 370;
   // }

   // public imgSize() {
   //    return {
   //       height: this.size / 100 * 224 + 'px',
   //       width: this.size / 100 * 318 + 'px'
   //    };
   // }

   // public contentStyle() {
   //    return {
   //       padding: this.size * 20 + 'px'
   //    };
   // }

   // public contentFont() {
   //    return this.size / 100 * 16;
   // }

   public onClick() {
      this.$router.push(`/listing/${this.data.id}`);
   }
}
